import { Container } from '../../components/Container/Container';
import { Header } from './components/Header/Header';
import { Cards } from './components/Cards/Cards';
import { LoyaltyModal } from './components/LoyaltyModal';
import { EmptyState } from './components/EmptyState/EmptyState';
import { DeleteModal } from './components/DeleteModal/DeleteModal';
import { ConfirmActivateModal } from './components/ConfirmActivateModal';
import { useLoyaltyProgram } from './useLoyaltyProgram';

export function Loyalty() {
  const {
    programs,
    form,
    loading,
    saving,
    openModal,
    deleting,
    pendingActivation,
    onChange,
    openCreate,
    openEdit,
    closeModal,
    save,
    toggleStatus,
    confirmActivation,
    cancelActivation,
    askDelete,
    cancelDelete,
    confirmDelete,
  } = useLoyaltyProgram();

  return (
    <Container>
      <Header onOpenAddModal={openCreate} />

      {!loading && programs.length === 0 ? (
        <EmptyState onOpenAddModal={openCreate} />
      ) : (
        <Cards
          data={programs}
          loading={loading}
          edit={openEdit}
          toggleStatus={toggleStatus}
          onDelete={askDelete}
        />
      )}

      {openModal && (
        <LoyaltyModal
          open={openModal}
          onClose={closeModal}
          form={form}
          onChange={onChange}
          onSave={save}
          saving={saving}
          isEdit={Boolean(form.id)}
        />
      )}

      {deleting && (
        <DeleteModal program={deleting} onClose={cancelDelete} onConfirm={confirmDelete} />
      )}

      <ConfirmActivateModal
        pendingActivation={pendingActivation}
        currentActive={programs.find((p) => p.Status)}
        onClose={cancelActivation}
        onConfirm={confirmActivation}
      />
    </Container>
  );
}
